#import "../fragments/enrollment-form-fragment.graphql"

mutation SubmitInboxEnrollmentForm {
    inboxEnrollmentFormSubmit {
        enrollmentForm {
            ...EnrollmentFormFragment
        }
    }
}
